import React from 'react'

import facebook from '../../imagenes/header/facebook-nuevo.png'
// import facebook2x from '../../imagenes/header/facebook@2x.png'
// import facebook3x from '../../imagenes/header/facebook@3x.png'
import twitter from '../../imagenes/header/x-nuevo.png'
// import twitter2x from '../../imagenes/header/twitter@2x.png'
// import twitter3x from '../../imagenes/header/twitter@3x.png'
import instagram from '../../imagenes/header/instagram-nuevo.png'
// import instagram2x from '../../imagenes/header/instagram@2x.png'
// import instagram3x from '../../imagenes/header/instagram@3x.png'
import whatsapp from '../../imagenes/header/whatsapp-nuevo.png'
// import whatsapp2x from '../../imagenes/header/whatsapp@2x.png'
// import whatsapp3x from '../../imagenes/header/whatsapp@3x.png'
import youtube from '../../imagenes/header/youtube-nuevo.png'
// import youtube2x from '../../imagenes/header/youtube@2x.png'
// import youtube3x from '../../imagenes/header/youtube@3x.png'
import mail from '../../imagenes/header/mail-nuevo.png'
// import mail2x from '../../imagenes/header/mail@2x.png'
// import mail3x from '../../imagenes/header/mail@3x.png'
import telegram from '../../imagenes/header/telegram-nuevo.png'
// import telegram2x from '../../imagenes/header/telegram@2x.png'
// import telegram3x from '../../imagenes/header/telegram@3x.png'
import { Link } from 'react-router-dom'
//import Modal from 'react-responsive-modal';
//import { destinosAPI } from '../../utils/funcionesAPI'
//import {manejadorDeRespuesta} from '../../utils/Tools'
//import {RUTA_IMAGEN} from '../../utils/rutasFijas'


class RedesSociales extends React.Component {
  constructor(props) {
      super(props)
      this.state = {open: false, destinosWhatsapp: []};

      //this.handleLogoutClick = this.handleLogoutClick.bind(this);

  }

/*   alAbrirElModal = () => {

    var _this = this;

    // FC: traer prod por orig, des, fecha
    let data = JSON.stringify({peticion: 'traerDestinosWhatsapp'});
    destinosAPI(data)
            .then(respuesta => {
              if(manejadorDeRespuesta(_this.props, respuesta)) {
                _this.setState({destinosWhatsapp: respuesta.data,  open: true});
              }

            });
    };

    alCerrarElModal = () => {
      this.setState({ open: false });
    };
 */
    render() {
      // const { open } = this.state;
      return (
              <ul style={{marginTop: '8px'}}>
                <li className="social-network">
                  <a href="https://www.facebook.com/pedrazavyt/" target="_blank" rel="noopener noreferrer">
                    <img src={facebook} alt="Logo de Facebook. Al clickearlo, iremos a la p&aacute;gina de Facebook de Pedraza Viajes" width="36" height="36"  />
                  </a>
                </li>
                <li className="social-network">
                  <a href="https://twitter.com/pedrazaviajes" target="_blank" rel="noopener noreferrer">
                    <img src={twitter} alt="Logo de X. Al clickearlo, iremos a la p&aacute;gina de X de Pedraza Viajes" width="36" height="36"  />
                  </a>
                </li>
                <li className="social-network">
                  <a href="https://www.instagram.com/pedrazaviajes/" target="_blank" rel="noopener noreferrer">
                    <img src={instagram} alt="Logo de Instagram. Al clickearlo, iremos a la p&aacute;gina de Instagram de Pedraza Viajes" width="36" height="36" />
                  </a>
                </li>
                <li className="social-network" style={{cursor: 'pointer'}}>
                  <a href={`https://api.whatsapp.com/send?phone=5491155822610&text=Hola,%20quisiera%20asesoramiento`} target="_blank" >
                    <img src={whatsapp} alt="Logo de Whatsapp. Al clickearlo, escribiremos al Whatsapp de Pedraza Viajes" width="36" height="36" />
                  </a>
                </li>
                <li className="social-network" style={{cursor: 'pointer'}}>
                  <a href="https://t.me/PedrazaViajes_bot"  target="_blank" rel="noopener noreferrer">
                    <img src={telegram} alt="Logo de Telegram. Al clickearlo, escribiremos al Telegram de Pedraza Viajes" width="36" height="36" />
                  </a>
                </li>
                <li className="social-network">
                  <a href="http://www.youtube.com/c/PedrazaViajesYTurismoBuenosAires" target="_blank" rel="noopener noreferrer">
                    <img src={youtube} alt="Logo de Youtube. Al clickearlo, iremos al canal de Youtube" width="36" height="36" />
                  </a>
                </li>
                <li className="social-network">
                  <Link to="/contacto" >
                    <img src={mail} alt="Lleva al formuario de Contacto" width="36" height="36"  />
                  </Link>
                </li>
               {/*  <Modal  open={open} onClose={this.alCerrarElModal}  center>
                  <h2 style={{'fontSize': '1.2rem'}}>Consultanos via whatsapp haciendo click en el destino que deseas</h2>
                    <hr />
                    <div className="text-center">
                      {
                        this.state.destinosWhatsapp.map((unDestino) => {
                        return <a key={unDestino.codigoDestino} className="linkModal" href={`https://api.whatsapp.com/send?phone=${unDestino.whatsapp}&text=Hola,%20necesito%20asesoramiento%20para%20${unDestino.denominacionDestino}`} target="_blank" rel="noopener noreferrer">
                          <img className="iconoWhatsappModal" src={whatsapp} alt="Logo de Whatsapp. Al clickearlo, escribiremos al Whatsapp de Pedraza Viajes" width="36" height="36"
                            />
                          <img width="130" src={`${RUTA_IMAGEN}/destinos/bg/${unDestino.imagen}`} alt={unDestino.imagen} />
                          <span className="textoWhatsappModal">{unDestino.denominacionDestino}</span>
                                </a>

                        })
                      }

                  </div>
                </Modal> */}
            </ul>

        )
    }
}
//onClick={this.onOpenModal}
//href="https://api.whatsapp.com/send?phone=5491155822610&text=Hola,%20necesito%20asesoramiento%20" target="_blank" rel="noopener noreferrer"
export default RedesSociales



// WEBPACK FOOTER //
// ./src/components/Global/RedesSociales.js